import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error tracking service here
    console.error('Uncaught error:', error, errorInfo);
  }

  render() {
    console.log('ERROR BOUNDARY', this.state);
    if (this.state.hasError) {
      // Display a fallback UI
      return <div>Oops! Something went wrong.</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
